function Footer() {
  return (
    <footer>
      <div className="logo-slogan-container">
        <img
          src="/images/TRAVA-LIGHT.svg"
          alt="trava's light logo"
          srcSet={`/images/TRAVA-LIGHT.svg 80w, /images/trava-light-large.svg 200w`}
          sizes="(max-width: 1020px) 80px, 200px"
        />
        <p className="slogan-footer">Take the work out of travel.</p>
      </div>
      <div className="desktop-info-footer">
        <div className="social-icons-container">
          <a href="https://trava.app.link/web-signup">
            <img
              height={50}
              width={50}
              src="/images/APP_STORE.svg"
              alt="app store link"
            />
          </a>
          <a href="https://trava.app.link/web-signup">
            <img
              height={50}
              width={50}
              src="/images/PLAY_STORE.svg"
              alt="play store link"
            />
          </a>
          <a href="https://www.tiktok.com/@trava.app">
            <img
              height={50}
              width={50}
              src="/images/TIKTOK.svg"
              alt="tiktok link"
            />
          </a>
          <a href="https://www.instagram.com/trava.app/">
            <img
              height={50}
              width={50}
              src="/images/INSTAGRAM.svg"
              alt="instagram link"
            />
          </a>
          <a href="https://www.reddit.com/r/trava_app/">
            <img
              height={50}
              width={50}
              src="/images/REDDIT.svg"
              alt="reddit link"
            />
          </a>
        </div>
        <div className="privacy-container">
          <button
            onClick={() => {
              window.location.href = "mailto:support@hellotrava.com";
            }}
            className="margin-bottom no-border"
          >
            <p>Contact</p>
          </button>
        </div>
        <div className="copyright-text">
          <p>© Copyright 2025 Trava. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export { Footer };
